import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../../Loading/LoadingView';
import AdvForm from '../../../CommonComponents/AdvForm';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import {
  createCustomPropType,
  isNumeric,
  isNumericFormatted,
  isUuid,
} from '../../../../js/app/react/validators';
import Footer from '../../Footer/FooterContainer';

export class DistributionYears extends Component {
  constructor(props) {
    super(props);

    this.onDistributionYearsBlur = this.onDistributionYearsBlur.bind(this);
  }

  onDistributionYearsBlur(valueArg) {
    const { goalId, clientId, whatIfTemplate, storeData } = this.props;

    let value = valueArg;

    if (isNumericFormatted(valueArg)) {
      if (typeof valueArg === 'string') {
        value = +valueArg.replace(/,/g, '');
      }
    } else {
      value = 0;
    }

    advInputTextChanged(
      clientId,
      storeData(goalId, whatIfTemplate.WhatIfType),
      'WhatIf.DistributionYears',
    )(value);
  }

  render() {
    const {
      groupTitle,
      clientId,
      title,
      whatIf,
      isLoading,
      applyWhatIf,
      fpId,
      goalId,
      whatIfTemplate,
    } = this.props;

    const { DistributionYears: distributionYears } = whatIf;

    return (
      <div className="what-ifs-layout">
        {isLoading && <Loading />}

        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>

        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>

          <AdvForm>
            <ValidationErrors clientId={clientId} />

            <ul className="what-ifs-form-fields what-ifs-box loaded">
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>

              <li className="what-ifs-decumulation-distribution-years-form-field">
                <AdvInputWrapper className="what-ifs-input-wrapper">
                  <AdvInput
                    autoComplete="off"
                    type="text"
                    maxLength="5"
                    onBlur={this.onDistributionYearsBlur}
                    value={distributionYears}
                    className="what-ifs-input"
                  />
                </AdvInputWrapper>
              </li>
            </ul>
          </AdvForm>
        </div>

        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}

DistributionYears.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

DistributionYears.propTypes = {
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  whatIf: PropTypes.shape({
    DistributionYears: PropTypes.number,
  }).isRequired,
  whatIfTemplate: PropTypes.shape({
    WhatIfType: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
};
